function formatUsd(value) {
    return `$${Number.isInteger(value) ? value : value.toFixed(2)}`;
}
/**
 * Resolves the seller commission for a single rule as a money amount:
 * - PERCENTAGE: total_price * commission_amount / 100
 * - FIXED: commission_amount as-is
 * - fallback (rule carries no usable commission): total_price - net_price (the margin)
 */
function commissionAmountFor(rule) {
    const { commission_type, commission_amount, total_price, net_price } = rule;
    const fromCommission = commission_type === "PERCENTAGE"
        ? (total_price * commission_amount) / 100
        : commission_amount;
    if (Number.isFinite(fromCommission) && fromCommission > 0) {
        return fromCommission;
    }
    if (Number.isFinite(total_price) &&
        Number.isFinite(net_price) &&
        total_price > net_price) {
        return total_price - net_price;
    }
    return null;
}
/**
 * Derives the seller commission amount (money, not percentage) shown on the
 * service card from its availability rules. Companion to {@link computeCommissionRange}
 * which returns the percentage; rates can change, so the card shows a "from" value.
 */
export function computeCommissionAmountRange(rules) {
    const amounts = rules
        .map(commissionAmountFor)
        .filter((amount) => typeof amount === "number" && amount > 0);
    if (amounts.length === 0)
        return null;
    const min = Math.min(...amounts);
    const max = Math.max(...amounts);
    return min === max ? formatUsd(min) : `${formatUsd(min)} – ${formatUsd(max)}`;
}
